import { Link, useNavigate } from "react-router-dom";
import Aside from "../../components/Aside";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Button from "../../components/form-controls/Button";
import { useCurrentAccount } from "../../hooks/useCurrentAccount";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import Input from "../../components/form-controls/Input";
import InvalidFeedback from "../../components/InvalidFeedback";
import { useCallback, useEffect, useMemo, useState } from "react";
import { AlertService } from "../../services/Alert";
import Papa from 'papaparse';
import Select from 'react-select'
import * as NativeSelect from '../../components/form-controls/Select';
import ContentEditable from 'react-contenteditable'
import { AccountService } from "../../services/AccountsService";
import { APPS } from "../../constants";
import { MetaService } from "../../services/MetaService";
import { BulkSenderService } from "../../services/BulkSenderService";
import { useTranslation } from "react-i18next";
import PreviewMessageWa from "./PreviewMessageWa";
import { RCSService } from "../../services/RCSService";
import { get } from "http";
import { FlowsService } from "../../services/FlowsServices";

interface FormValues {
    name: string;
    sub_account_id: string;
    csv: string;
    header_number: string;
    header_name: string;
    data_process: string;
    type_send: string;
    plantilla: string;
    template_variables: any[];
    btns_variables: any[];
    send_sms_on_fail: string;
    sms_message: string;
    channel: string;
    token_short_link: string;

    sms_link: boolean;
    sms_link_number: string;
    sms_link_text: string;
    sms_mascara: string;

    active_replay_msg: boolean;
    replay_msg: {
        time_to_send: number;
        type_time: 'minutes' | 'hours';
        conditions: {
            contact: boolean;
            read: boolean;
            delivery: boolean;
        };
        plantilla_id: number;
        template_variables: any[];
        btns_variables: any[];
    };

    general_flow: boolean;
    general_flow_select: string;
    buttons_flow: boolean;
    message_var: boolean;
    headers_message_var: string
    [key: string]: any;
}


function BulkSendersCreatePage() {

    const { t } = useTranslation();

    const { account } = useCurrentAccount();

    const navigate = useNavigate();

    const [fieldsCSVFile, setFieldsCSVFile] = useState([])
    const [templates, setTemplates] = useState([])
    const [templatesRCS, setTemplatesRCS] = useState([])
    const [template, setTemplate] = useState([])
    const [replyTemplate, setReplyTemplate] = useState([])
    const [channels, setChannels] = useState([])
    const [isRefresingChannels, setIsRefresingChannels] = useState(false)
    const [flows, setFlows] = useState([]);
    const [masks, setMasks] = useState([])
    const [subAccounts, setSubAccounts] = useState([])
    const [valuesFromCSV, setValuesFromCSV] = useState<{ header: string; value: string }[]>([]);
    const [messageVar, setMessageVar] = useState<string>('')

    const whatsappBusiness = useMemo(() => {
        const exists = channels.find(c => c.app.toUpperCase() === APPS.WHATSAPP_BUSINESS)

        if (!exists || (!exists?.cm_wab_id && !exists?.meta_waba_id)) return false

        return exists
    }, [channels])

    const whatsappStandar = useMemo(() => channels.find(c => c.app.toUpperCase() === APPS.WHATSAPP_STANDAR), [channels])

    const whatsAppnumbers = useMemo(() => {
        let options = [];

        if (whatsappBusiness) {
            const wab = whatsappBusiness.meta_phone_number || whatsappBusiness.cm_number
            options.push({
                value: wab,
                label: `WhatsApp Business (${wab})`
            })
        }
        if (whatsappStandar) {
            options.push({
                value: whatsappStandar.number,
                label: `WhatsApp (${whatsappStandar.number})`
            })
        }

        return options;
    }, [whatsappBusiness, whatsappStandar])

    const sms = useMemo(() => {
        let exists = channels.find(c => c.app.toUpperCase() === APPS.SMS);

        if (exists) return exists;

        return false
    }, [channels])

    const rcs = useMemo(() => {
        let exists = channels.find(c => c.app.toUpperCase() === APPS.RCS);

        if (exists) return exists;

        return false
    }, [channels])

    const defaultValues: FormValues = {
        name: '',
        sub_account_id: '',
        csv: '',
        header_number: '',
        header_name: '',
        data_process: '',
        type_send: '',
        plantilla: '',
        template_variables: [],
        btns_variables: [],
        send_sms_on_fail: '',
        sms_message: '',
        channel: '',
        token_short_link: '',

        sms_link: false,
        sms_link_number: '',
        sms_link_text: '',
        sms_mascara: '',

        active_replay_msg: false,
        replay_msg: {
            time_to_send: 0,
            type_time: 'minutes', // hours|minutes
            conditions: {
                contact: false, // inicio conversación
                read: false, // leyo mensaje
                delivery: false, // si entrego mensaje
            },
            plantilla_id: 0,
            template_variables: [],
            btns_variables: [],
        },

        general_flow: false,
        general_flow_select: '',
        buttons_flow: false,
        message_var: false,
        headers_message_var: ''

    }

    const { control, register, watch, trigger, reset, setValue, getValues, handleSubmit, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const templateParameters = useFieldArray({
        control,
        name: "template_variables",
    });

    const replyTemplateParameters = useFieldArray({
        control,
        name: "replay_msg.template_variables",
    });

    const btnsParameters = useFieldArray({
        control,
        name: "btns_variables",
    });

    const replyBtnsParameters = useFieldArray({
        control,
        name: "replay_msg.btns_variables",
    });

    const campaignType = watch('type_send')
    const send_sms_on_fail = watch('send_sms_on_fail')
    const csvFile: any = watch('csv')

    const sms_message = watch('sms_message')
    const plantilla = watch('plantilla')
    const channel = watch('channel')
    const variables = watch('template_variables')
    const replyVariables = watch('replay_msg.template_variables')
    const message_var = watch('message_var');

    const sms_link = watch('sms_link')
    const sms_link_number = watch('sms_link_number')
    const sms_link_text = watch('sms_link_text')

    const replyPlantilla = watch('replay_msg.plantilla_id')
    const active_replay_msg = watch('active_replay_msg')
    const general_flow = watch('general_flow')
    const buttons_flow = watch('buttons_flow')

    const header = useMemo(() => template.find(t => t.type === 'HEADER'), [template])
    const body = useMemo(() => template.find(t => t.type === 'BODY'), [template])
    const footer = useMemo(() => template.find(t => t.type === 'FOOTER'), [template])
    const buttons = useMemo(() => template.find(t => t.type === 'BUTTONS'), [template])
    const replyHeader = useMemo(() => replyTemplate.find(t => t.type === 'HEADER'), [replyTemplate])
    const replyBody = useMemo(() => replyTemplate.find(t => t.type === 'BODY'), [replyTemplate])
    const replyFooter = useMemo(() => replyTemplate.find(t => t.type === 'FOOTER'), [replyTemplate])
    const replyButtons = useMemo(() => replyTemplate.find(t => t.type === 'BUTTONS'), [replyTemplate])

    const sms_message_final = useMemo(() => `${sms_message}${sms_link ? ` https://wa.me/${sms_link_number}?text=${encodeURIComponent(sms_link_text)}` : ''}`, [sms_message, sms_link, sms_link_number, sms_link_text])


    const addVariable = (text) => {
        // const newMessage = sms_message + `${String.fromCharCode(160)}{{${text}}}${String.fromCharCode(160)}`
        const previus_char = sms_message.slice(-1);
        const space = String.fromCharCode(160);

        const newMessage = sms_message + `${previus_char === space ? '' : space}{{${text}}}${space}`;

        setValue('sms_message', newMessage)
        trigger('sms_message')
    }

    const formatPreviewSMS = useCallback(
        () => {
            const regex = new RegExp(/{{([^}]+)}}/g)
            // console.log(messageSMS)
            // .replace(/\s+/g, ' ') reemplzar espacios en blanco
            return sms_message.replace(regex, (match, variable) => {
                const isValid = fieldsCSVFile.find(f => f.value === variable);
                return isValid ?
                    `<span class="badge bg-soft-info text-info" contenteditable="false">${match}</span>` :
                    `<span class="badge bg-soft-danger text-danger" contenteditable="false">${match}</span>`
            })

        },
        [sms_message],
    )

    const getChannels = async () => {
        const { data } = await AccountService.getChannels(account.id)
        setChannels(data)
    }

    const getFlows = async () => {
        const { data } = await FlowsService.getFlows(account.id);
        const activeFlows = data.filter((item: any) => item.status === "active");
        const mappedFlows = activeFlows.map((item: any) => ({
            value: item._id,
            label: item.name
        }));
        setFlows(mappedFlows);
    }

    const refreshChannels = async () => {
        setIsRefresingChannels(true)
        await getChannels()
        setIsRefresingChannels(false)
    }

    const isValidMediaTemplate = (body) => {
        const component = JSON.parse(body)
        const header = component.find(c => c.type === 'HEADER');

        if (!header) return true

        const type = header.format.toLowerCase()

        if (type === 'text') return true;


        return header[type] ? true : false
    }

    const getTemplates = async () => {
        const { data } = await MetaService.getTemplates(account.id, 'APPROVED')

        let tmplts = data
            .filter(row => isValidMediaTemplate(row.body))
            .map(row => ({ value: row.id, label: `${row.name} (${row.language})`, data: row }))

        setTemplates(tmplts)
    }

    const getSubAccounts = async () => {
        const { data } = await AccountService.getSubaccounts(account.id)
        let subaccts = [{ value: '', label: 'Sin subcuenta' }, ...data.sub_accounts.map(a => ({ value: a.id, label: a.name }))];
        setSubAccounts(subaccts)
    }

    const getTemplatesRCS = async () => {
        const { data } = await RCSService.getTemplates(account.id, 'APPROVED')


        // data.map( row => { 
        //     console.log(row.body)
        //     const component = JSON.parse(row.body)
        //     const header = component.find( c => c.type === 'HEADER');
        //     console.log(header)

        //     if(!header) return true

        //     const type = header.format.toLowerCase()
        //     console.log(type)

        //     if(type === 'text') return true;

        //     console.log(header[type])

        //     return header[type] ? true: false
        // })


        let tmplts = data
            .filter(row => isValidMediaTemplate(row.body))
            .map(row => ({ value: row.id, label: `${row.name} (${row.language})`, data: row }))

        setTemplatesRCS(tmplts)
    }


    const buildTemplateVariables = ({ template_variables, btns_variables }) => {
        let templateVariables: any = {
            body: {}
        }

        if (header && header.format !== 'TEXT') {
            const format = header.format.toLowerCase();
            templateVariables.header = [
                {
                    type: format,
                    [format]: {
                        link: header[format]
                    }
                }
            ]
        }


        for (const row of template_variables) {
            templateVariables.body[row.label] = row.value;
        }

        if (btns_variables.length) {

            let buttons = []
            for (const btn of btns_variables) {

                buttons.push({
                    index: btn.index,
                    column: btn.value
                })

            }

            templateVariables.buttons = buttons;
        }

        return JSON.stringify(templateVariables);
    }

    const submit = async (data) => {
        try {
            const form = new FormData()
            form.append('name', data.name)
            form.append('account_id', account.id)
            form.append('sub_account_id', data.sub_account_id || '')

            form.append('csv', data.csv[0])
            form.append('header_number', data.header_number)
            form.append('header_name', data.header_name)
            form.append('data_process', data.data_process)

            form.append('type_send', data.type_send) // WA | SMS | RCS

            if (data.type_send === 'WA' || data.type_send === 'RCS') {
                form.append('plantilla_id', data.plantilla.value)
                form.append('template_variables', buildTemplateVariables(data))
                form.append('send_sms_on_fail', data.send_sms_on_fail ? '1' : '0')
            }

            if (data.send_sms_on_fail || data.type_send === 'SMS') {
                // form.append('sms_message', data.sms_message.trim())
                form.append('sms_message', sms_message_final.trim())
                form.append('sms_mascara', data.sms_mascara)
                // form.append('token_short_link', data.token_short_link)
            }

            if (data.active_replay_msg) {
                const replay_msg = {
                    time_to_send: data.replay_msg.time_to_send,
                    type_time: data.replay_msg.type_time,
                    conditions: {
                        contact: data.replay_msg.conditions.contact,
                        read: data.replay_msg.conditions.read,
                        delivery: data.replay_msg.conditions.delivery,
                    },
                    plantilla_id: data.replay_msg.plantilla_id.value,
                    template_variables: buildTemplateVariables({ template_variables: data.replay_msg.template_variables, btns_variables: data.replay_msg.btns_variables })
                }

                form.append('replay_msg', JSON.stringify(replay_msg))

            }

            const flows_json = {
                general: data.general_flow ? data.general_flow_select?.value || "" : "",
                btns: []
            };

            if (data.buttons_flow) {
                flows_json.btns = flows_json.btns || [];
                Object.keys(data).forEach(key => {
                    if (key.startsWith('button_flow_select_')) {
                        const buttonData = data[key];
                        if (buttonData && buttonData.value && buttonData.text_btn) {
                            flows_json.btns.push({
                                flow: buttonData.value,
                                text: buttonData.text_btn
                            });
                        }
                    }
                });
            }
            form.append('flows_data', JSON.stringify(flows_json));

            await BulkSenderService.send(form)

            await AlertService.success('Éxito!', 'La campaña se enviará en breve');

            navigate(-1)
        } catch (error) {
            console.error(error)
            AlertService.error('¡Error!', 'No se pudo enviar la campaña, intenta más tarde.')
        }


    }

    const getMasksSMS = async () => {
        const { data } = await AccountService.getMasksSMS(account.account_id)
        setMasks(data.map(mask => ({ value: mask, label: mask })))
    }

    const replaceVariablesInMessage = (message) => {
        return message.replace(/{{(.*?)}}/g, (match, p1) => {
            const variableValue = valuesFromCSV.find(item => item.header === p1)?.value || match;
            return variableValue;
        });
    };


    const replaceVariablesInBody = (body: any, type: string) => {
        if (!body || typeof body.text !== 'string') {
            console.warn("El cuerpo no es válido o no contiene texto:", body);
            return body;
        }

        const messageBody = body.text;
        const sourceVariables = type === 'message' ? variables : replyVariables;

        const replacedBody = messageBody.replace(/{{(\d+)}}/g, (match, p1) => {
            const variable = sourceVariables.find(v => v.label === p1);

            if (variable) {
                const valueFromCSV = valuesFromCSV.find(item => item.header === variable.value)?.value;
                return valueFromCSV || match;
            }
            return match;
        });

        return replacedBody === messageBody ? body : { ...body, text: replacedBody };
    };

    useEffect(() => {
        let file: File = csvFile[0];

        if (file && file.type !== 'text/csv') {
            AlertService.toastError('Solo se permiten archivo .csv')
            setValue('csv', '')

            return;
        }

        if (file) {
            Papa.parse(file, {
                delimiter: ',',
                header: true,
                complete: (results) => {
                    const headers = results.meta.fields
                    const firstRow = results.data[0];

                    const headerValues = headers.map(h => ({
                        header: h,
                        value: firstRow[h] || ''
                    }));


                    setFieldsCSVFile(headers.map(h => ({ value: h, label: h })))
                    setValue('header_name', '')
                    setValue('header_number', '')
                    setValuesFromCSV(headerValues);
                },
                error: () => {
                    AlertService.error('Error', 'Ocurrió un error al leer el archivo CSV, verifica su estructura e intenta nuevamente.')
                    setValue('csv', '')
                },
            })

        }
    }, [csvFile])

    useEffect(() => {
        getSubAccounts()
        getChannels()
    }, [])

    useEffect(() => {
        getTemplates()
    }, [whatsappBusiness])


    useEffect(() => {
        if (rcs) {
            getTemplatesRCS();
        }
    }, [rcs])

    useEffect(() => {

        let templateSelected: any = plantilla;

        setTemplate(templateSelected ? JSON.parse(templateSelected.data.body) as any : [])

    }, [plantilla])

    useEffect(() => {

        let templateSelected: any = replyPlantilla;

        setReplyTemplate(templateSelected ? JSON.parse(templateSelected.data.body) as any : [])

    }, [replyPlantilla])

    useEffect(() => {

        templateParameters.remove()

        if (!body) {
            // setValue('template_variables', [])
            return;
        }

        const regex = /{{[0-9]}}/g;

        let tokens = body.text.match(regex);
        if (!tokens) {
            // setValue('template_variables', [])
            return;
        }

        tokens = tokens
            .map(t => t.replace(/{{([0-9])}}/g, '$1'))
            .sort()
            .filter((value, index, array) => array.indexOf(value) === index)
        // .map( t => ({ [t]: '' }))

        for (const token of tokens) {
            templateParameters.append({
                label: token,
                value: '',
            })
        }
    }, [body])

    useEffect(() => {

        replyTemplateParameters.remove()

        if (!replyBody) {
            // setValue('template_variables', [])
            return;
        }

        const regex = /{{[0-9]}}/g;

        let tokens = replyBody.text.match(regex);
        if (!tokens) {
            // setValue('template_variables', [])
            return;
        }

        tokens = tokens
            .map(t => t.replace(/{{([0-9])}}/g, '$1'))
            .sort()
            .filter((value, index, array) => array.indexOf(value) === index)
        // .map( t => ({ [t]: '' }))

        for (const token of tokens) {
            replyTemplateParameters.append({
                label: token,
                value: '',
            })
        }
    }, [replyBody])

    useEffect(() => {

        btnsParameters.remove()

        if (!buttons) {
            return;
        }

        for (let index = 0; index < buttons.buttons.length; index++) {
            const btn = buttons.buttons[index];

            if (btn.url && btn.url.endsWith('{{1}}')) {
                btnsParameters.append({
                    btn,
                    index: index,
                    value: ''
                })
            }

        }

    }, [buttons])

    useEffect(() => {

        replyBtnsParameters.remove()

        if (!replyButtons) {
            return;
        }

        for (let index = 0; index < replyButtons.buttons.length; index++) {
            const btn = replyButtons.buttons[index];

            if (btn.url && btn.url.endsWith('{{1}}')) {
                replyBtnsParameters.append({
                    btn,
                    index: index,
                    value: ''
                })
            }

        }

    }, [replyButtons])

    useEffect(() => {
        if (sms) {
            getMasksSMS()
        }
    }, [sms])

    useEffect(() => {
        getFlows();
    }, [])


    return (
        <>
            <Header />
            <Aside />

            <main id="content" role="main" className="main">

                <div className="content container-fluid">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t('platform.platform-title')}</span></li>
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t('bulk-senders.bulk-title')}</span></li>
                                        <li className="breadcrumb-item active" aria-current="page">{t("bulk-senders.add-campaign")}</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>

                        <div className="row align-items-center mt-3">
                            <div className="col-sm mb-2 mb-sm-0 d-flex align-items-center">

                                <button type="button" title="button" className="btn btn-soft-primary btn-icon me-3" onClick={() => navigate(-1)}>
                                    <i className="bi-chevron-left"></i>
                                </button>

                                <h2 className="page-header-title m-0 me-3 text-dark">{t("bulk-senders.add-campaign")}</h2>
                            </div>

                            <div className="col-sm-auto">
                                <Button className="btn btn-primary btn-sm" onClick={handleSubmit(submit)} disabled={!isValid} isLoading={isSubmitting} ><i className="bi-save2 me-2"></i> {t("btn-save")} </Button>
                            </div>
                        </div>

                    </div>


                    <div className="row justify-content-center">
                        <div className="col-8">
                            <div className="card ">
                                <div className="card-body">
                                    <h2 className="card-title h4">{t('bulk-senders.campaign-title')}</h2>
                                    <p className="small">{t('bulk-senders.campaign-text')}</p>

                                    <div className="mb-3">
                                        <Input label={t('bulk-senders.name-label')} errors={errors.name} {...register('name', { required: true })} />
                                    </div>

                                    <div className='mb-3'>
                                        <label className="form-label" >Subcuenta <span className="form-label-secondary">(Opcional)</span></label>
                                        <Controller
                                            control={control}
                                            name='sub_account_id'
                                            rules={{ required: false }}
                                            render={
                                                ({
                                                    field: { onChange, value },
                                                    fieldState: { error }
                                                }) => {
                                                    return <Select
                                                        name="Subcuenta (opcional)"
                                                        options={subAccounts}
                                                        className={error ? 'form-select-custom is-invalid' : ''}
                                                        classNamePrefix='form-select-custom'
                                                        placeholder='Subcuenta'
                                                        isClearable
                                                        onChange={(option) => onChange(option?.value || '')}
                                                    />
                                                }
                                            }
                                        />
                                    </div>


                                </div>
                            </div>

                            <hr />
                            <div className="card ">
                                <div className="card-body">
                                    <h2 className="card-title h4">{t('bulk-senders.data-base-title')}</h2>
                                    <p className="small">{t('bulk-senders.data-base-text-1')} <a href="/assets/layout-db.csv" target="_blank" className="text-success fw-semibold">{t('bulk-senders.here-text')} <i className="bi-box-arrow-up-right"></i></a> {t('bulk-senders.data-base-text-2')}</p>

                                    <div className="mb-3">
                                        <Input type='file' label={t('bulk-senders.file-csv')} errors={errors.csv} {...register('csv', { required: true })} />
                                    </div>

                                    <div className="mb-3">
                                        <div className="alert alert-soft-secondary" role="alert">
                                            <h5>{t('bulk-senders.column-assignment')}</h5>
                                            <p>{t('bulk-senders.assignment-text')}</p>

                                            <div className="row">
                                                <div className="col-4">
                                                    <div className="mb-3">
                                                        <label className="form-label" >{t('bulk-senders.client-name')}</label>
                                                        <Controller
                                                            control={control}
                                                            name='header_name'
                                                            rules={{ required: true }}
                                                            render={
                                                                ({
                                                                    field: { onChange, value },
                                                                    fieldState: { error }
                                                                }) => {

                                                                    return (
                                                                        <>
                                                                            <Select
                                                                                name="Nombre del cliente"
                                                                                options={fieldsCSVFile}
                                                                                className={error ? 'form-select-custom is-invalid' : ''}
                                                                                classNamePrefix='form-select-custom'
                                                                                placeholder={t('bulk-senders.client-name-placeholder')}
                                                                                onChange={(option) => onChange(option.value)}
                                                                                value={fieldsCSVFile.find(row => row.value === value) || ''}
                                                                            />
                                                                            <InvalidFeedback error={error} />
                                                                        </>
                                                                    )
                                                                }
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className='mb-3'>
                                                        <label className="form-label" >{t('bulk-senders.phone-number')}</label>
                                                        <Controller
                                                            control={control}
                                                            name='header_number'
                                                            rules={{ required: true }}
                                                            render={
                                                                ({
                                                                    field: { onChange, value },
                                                                    fieldState: { error }
                                                                }) => {
                                                                    return (
                                                                        <>
                                                                            <Select
                                                                                name="Número de teléfono"
                                                                                options={fieldsCSVFile}
                                                                                className={error ? 'form-select-custom is-invalid' : ''}
                                                                                classNamePrefix='form-select-custom'
                                                                                placeholder={t('bulk-senders.phone-number-placeholder')}
                                                                                onChange={(option) => onChange(option.value)}
                                                                                value={fieldsCSVFile.find(row => row.value === value) || ''}
                                                                            />
                                                                            <InvalidFeedback error={error} />
                                                                        </>
                                                                    )
                                                                }
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <div className='mb-3'>
                                                        <label className="form-label" >Procesar información adicional de CSV para</label>
                                                        <Controller
                                                            control={control}
                                                            name='data_process'
                                                            rules={{ required: true }}
                                                            render={
                                                                ({
                                                                    field: { onChange, value },
                                                                    fieldState: { error }
                                                                }) => {

                                                                    const options = [
                                                                        {
                                                                            label: 'Actualizar',
                                                                            value: 'update',
                                                                        },
                                                                        {
                                                                            label: 'Reemplazar',
                                                                            value: 'replace',
                                                                        },
                                                                        {
                                                                            label: 'Ignorar',
                                                                            value: 'ignore',
                                                                        },
                                                                    ]

                                                                    return (
                                                                        <>
                                                                            <Select
                                                                                name="Procesar información adicional de CSV"
                                                                                options={options}
                                                                                className={error ? 'form-select-custom is-invalid' : ''}
                                                                                classNamePrefix='form-select-custom'
                                                                                placeholder="Procesar información adicional de CSV"
                                                                                onChange={(option: any) => onChange(option.value)}
                                                                                value={options.find(row => row.value === value) || ''}
                                                                            />
                                                                            <InvalidFeedback error={error} />
                                                                        </>
                                                                    )
                                                                }
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <hr />

                            <div className="card ">
                                <div className="card-body">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h2 className="card-title h4">{t('bulk-senders.campaign-type')}</h2>
                                            <p className="small ">
                                                {t('bulk-senders.campaign-type-text')}
                                            </p>
                                        </div>
                                        <Button className="btn btn-white btn-sm" onClick={refreshChannels} isLoading={isRefresingChannels}>
                                            <i className="bi-arrow-clockwise"></i> {t('bulk-senders.update-btn')}
                                        </Button>
                                    </div>

                                    <Controller
                                        control={control}
                                        name='type_send'
                                        rules={{ required: true }}
                                        render={
                                            ({
                                                field: { onChange, value },
                                                fieldState: { error }
                                            }) => {
                                                return (
                                                    <>
                                                        <ul className={`list-group list-group-flush list-group-no-gutters ${error ? ' is-invalid-custom ' : ''}`}>
                                                            <li className={'list-group-item category py-5 px-3 ' + (value === 'WA' ? 'selected' : '')} onClick={() => onChange(whatsappBusiness === false ? '' : 'WA')}>
                                                                <div className="d-flex">
                                                                    <div className="category-icon">
                                                                        <img title="img" className="avatar avatar-xs" src="/assets/img/channels/whatsapp-business-icon.png" />
                                                                    </div>
                                                                    <div className="ms-3">
                                                                        <h4>{t('bulk-senders.wa-business')}</h4>
                                                                        <p className="mb-0">{t('bulk-senders.wa-business-text')}</p>
                                                                        {
                                                                            whatsappBusiness === false && (
                                                                                <div className="alert alert-danger mb-0 mt-2" role="alert">
                                                                                    No tienes la configuración necesaria para utilizar WhatsApp Business. Contacta a tu asesor para más información.
                                                                                </div>
                                                                            )
                                                                        }

                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li className={'list-group-item category py-5 px-3 ' + (value === 'SMS' ? 'selected' : '')} onClick={() => onChange(sms === false ? '' : 'SMS')}>
                                                                <div className="d-flex">
                                                                    <div className="category-icon">
                                                                        <img title="img" className="avatar avatar-xs" src="/assets/img/channels/sms-icon.png" />
                                                                    </div>
                                                                    <div className="ms-3">
                                                                        <h4>{t('bulk-senders.sms')}</h4>
                                                                        <p className="mb-0">{t('bulk-senders.sms-text')}</p>
                                                                        {
                                                                            sms === false && (
                                                                                <div className="alert alert-danger mb-0 mt-2" role="alert">
                                                                                    Para utilizar esta opción, ingresa tu nombre de usuario y contraseña de tu cuenta SMS para conectarla con nuestra plataforma. Haz clic <Link to="/channels" target="_blank" rel="noopener noreferrer" className="link text-white" >aquí</Link> configurar esta opción.
                                                                                </div>
                                                                            )
                                                                        }

                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li className={'list-group-item category py-5 px-3 ' + (value === 'RCS' ? 'selected' : '')} onClick={() => onChange(rcs === false ? '' : 'RCS')}>
                                                                <div className="d-flex">
                                                                    <div className="category-icon">
                                                                        <img title="img" className="avatar avatar-xs" src="/assets/img/channels/rcs-icon.png" />
                                                                    </div>
                                                                    <div className="ms-3">
                                                                        <h4>RCS</h4>
                                                                        <p className="mb-0">{t('bulk-senders.sms-rcs')}</p>
                                                                        {
                                                                            rcs === false && (
                                                                                <div className="alert alert-danger mb-0 mt-2" role="alert">
                                                                                    Para utilizar esta opción, ingresa tu nombre de usuario y contraseña de tu cuenta SMS para conectarla con nuestra plataforma. Haz clic <Link to="/channels" target="_blank" rel="noopener noreferrer" className="link text-white" >aquí</Link> configurar esta opción.
                                                                                </div>
                                                                            )
                                                                        }

                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                        <InvalidFeedback error={error} />
                                                    </>
                                                )
                                            }
                                        }
                                    />


                                </div>
                            </div>
                            <hr />

                            {
                                campaignType === 'WA' && (
                                    <>
                                        <div className="card">
                                            <div className="card-body">
                                                <h2 className="card-title h4">{t('bulk-senders.message-template')}</h2>
                                                <p className="small ">
                                                    {t('bulk-senders.select-template')}
                                                </p>

                                                <div className="mb-3">
                                                    <Controller
                                                        control={control}
                                                        name='plantilla'
                                                        rules={{ required: true }}
                                                        render={
                                                            ({
                                                                field: { onChange, value },
                                                                fieldState: { error }
                                                            }) => {
                                                                return (
                                                                    <>
                                                                        <Select
                                                                            options={templates}
                                                                            className={'form-select-custom ' + (error ? ' is-invalid' : '')}
                                                                            classNamePrefix='form-select-custom'
                                                                            placeholder={t('bulk-senders.message-template')}
                                                                            onChange={(data: any) => {
                                                                                onChange(data)
                                                                                setValue('buttons_flow', false);
                                                                                if (buttons && buttons.buttons) {
                                                                                    buttons.buttons.forEach((_, index) => {
                                                                                        setValue(`button_flow_select_${index}`, undefined);
                                                                                    });
                                                                                }
                                                                            }}
                                                                            value={value as any}
                                                                        />
                                                                        <InvalidFeedback error={error} />
                                                                    </>
                                                                )
                                                            }
                                                        }
                                                    />
                                                </div>


                                                {
                                                    (templateParameters.fields.length > 0 || btnsParameters.fields.length > 0) && (
                                                        <div className="mb-3">
                                                            <div className="alert alert-soft-secondary" role="alert">
                                                                <h5>Variables de plantilla</h5>
                                                                <p>La plantilla que seleccionaste requiere de variables extra antes de ser enviado, selecciona las columnas del archivo csv que corresponden a cada variables.</p>

                                                                {templateParameters.fields.length > 0 && <h6>Variables de cuerpo de mensaje</h6>}
                                                                {
                                                                    templateParameters.fields.map((field, index) => (
                                                                        <div className="d-flex align-items-center mb-2" key={field.id}>
                                                                            <label className="form-label mx-3" >{`{{${field.label}}}`}</label>
                                                                            <div className="flex-grow-1">
                                                                                <Controller
                                                                                    control={control}
                                                                                    name={`template_variables.${index}.value`}
                                                                                    rules={{ required: true }}
                                                                                    render={
                                                                                        ({
                                                                                            field: { onChange, value },
                                                                                            fieldState: { error }
                                                                                        }) => {
                                                                                            return (
                                                                                                <>
                                                                                                    <Select
                                                                                                        options={fieldsCSVFile}
                                                                                                        className={'form-select-custom ' + (error ? ' is-invalid' : '')}
                                                                                                        classNamePrefix='form-select-custom'
                                                                                                        placeholder={`Seleccionar columna para variable {{${field.label}}}`}
                                                                                                        onChange={(data: any) => onChange(data.value)}
                                                                                                        value={fieldsCSVFile.find(row => row.value === value) || ''}
                                                                                                    />
                                                                                                    <InvalidFeedback error={error} />
                                                                                                </>
                                                                                            )
                                                                                        }
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                }

                                                                {btnsParameters.fields.length > 0 && <h6 className="mt-5">Variables de botón dinámico</h6>}
                                                                {
                                                                    btnsParameters.fields.map((btn, index) => (
                                                                        <div className="d-flex align-items-center mb-2" key={index}>
                                                                            <label className="form-label mx-3" >Botón {btn.btn.text}</label>
                                                                            <div className="flex-grow-1">
                                                                                <Controller
                                                                                    control={control}
                                                                                    name={`btns_variables.${index}.value`}
                                                                                    rules={{ required: true }}
                                                                                    render={
                                                                                        ({
                                                                                            field: { onChange, value },
                                                                                            fieldState: { error }
                                                                                        }) => {
                                                                                            return (
                                                                                                <>
                                                                                                    <Select
                                                                                                        options={fieldsCSVFile}
                                                                                                        className={'form-select-custom ' + (error ? ' is-invalid' : '')}
                                                                                                        classNamePrefix='form-select-custom'
                                                                                                        placeholder={`Seleccionar columna para variable del botón ${btn.btn.text}`}
                                                                                                        onChange={(data: any) => onChange(data.value)}
                                                                                                        value={fieldsCSVFile.find(row => row.value === value) || ''}
                                                                                                    />
                                                                                                    <InvalidFeedback error={error} />
                                                                                                </>
                                                                                            )
                                                                                        }
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>
                                                    )
                                                }


                                                {/* <div className="mb-3">
                                                    <div className="form-check form-switch mb-4">
                                                        <input type="checkbox" className="form-check-input" id="send_sms_on_fail" {...register('send_sms_on_fail')} />
                                                        <label className="form-check-label" htmlFor="send_sms_on_fail">{t('bulk-senders.switch-sms')}</label>
                                                    </div>
                                                </div> */}

                                            </div>
                                        </div>
                                        <hr />

                                        <div className="card">
                                            <div className="card-body">
                                                <h2 className="card-title h4">Configuración de Flujos de Respuesta<i className="bi bi-share fw-bolder text-primary ms-1 fs-3"></i></h2>
                                                <p className="small mb-5">
                                                    Los flujos de respuesta son bots previamente configurados que se activan cuando el usuario responde un mensaje recibido o hace clic en un botón de la plantilla enviada. </p>

                                                <span className="divider-start text-primary fs-4 fw-bolder">Flujo General</span>

                                                <p className="small mb-5">
                                                    Se ejecuta si el usuario responde a un mensaje.
                                                </p>

                                                <div className="mb-5">
                                                    <div className="form-check form-switch mb-4">
                                                        <input title="input" type="checkbox" className="form-check-input" id="general_flow" {...register('general_flow')} />
                                                        <label className="form-check-label" htmlFor="general_flow">Activar Flujo general</label>
                                                    </div>
                                                </div>

                                                {
                                                    general_flow && (
                                                        <>
                                                            <h5 className="mb-2">Flujos <span className="text-danger">*</span></h5>
                                                            <div className="mb-7">
                                                                <Controller
                                                                    control={control}
                                                                    name='general_flow_select'
                                                                    rules={{ required: true }}
                                                                    render={
                                                                        ({
                                                                            field: { onChange, value },
                                                                            fieldState: { error }
                                                                        }) => {
                                                                            return (
                                                                                <>
                                                                                    <Select
                                                                                        options={flows}
                                                                                        className={'form-select-custom ' + (error ? ' is-invalid' : '')}
                                                                                        classNamePrefix='form-select-custom'
                                                                                        placeholder={'Selecciona un flujo'}
                                                                                        onChange={(data: any) => onChange(data)}
                                                                                        value={value as any}
                                                                                    />
                                                                                    <InvalidFeedback error={error} />
                                                                                </>
                                                                            )
                                                                        }
                                                                    }
                                                                />
                                                            </div>
                                                        </>
                                                    )
                                                }
                                                {buttons && buttons.buttons && buttons.buttons.length > 0 && (
                                                    <>
                                                        <span className="divider-start fs-4 fw-bolder text-primary">Flujo por botón</span>
                                                        <p className="small mb-5">
                                                            Se activa si el usuario hace clic en un botón de la plantilla, y cada botón puede tener un flujo diferente o compartir el mismo.
                                                        </p>

                                                        <div className="mb-7">
                                                            <div className="form-check form-switch mb-4">
                                                                <input type="checkbox" className="form-check-input" id="buttons_flow" {...register('buttons_flow')} />
                                                                <label className="form-check-label" htmlFor="buttons_flow">Activar Flujo por botón</label>
                                                            </div>
                                                            {buttons_flow && (
                                                                <h4 className="mb-2 text-success">Botones encontrados: {buttons.buttons.length}</h4>
                                                            )}
                                                        </div>
                                                        {buttons_flow && (
                                                            <>
                                                                <div className="row">
                                                                    {buttons.buttons.map((button, index) => (
                                                                        <div className="d-flex mb-7" key={index} style={{ width: '100%' }}>
                                                                            <div className="col-4">
                                                                                <h5 className="mb-2 text-muted">Texto del botón:</h5>
                                                                                <span className="d-block fw-bold text-primary">{button.text}</span>
                                                                            </div>
                                                                            <div className="col-8">
                                                                                <h5 className="mb-2 text-muted">Flujos (Opcional)</h5>
                                                                                <Controller
                                                                                    control={control}
                                                                                    name={`button_flow_select_${index}`}
                                                                                    rules={{ required: false }}
                                                                                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                                                                                        <>
                                                                                            <Select
                                                                                                options={flows}
                                                                                                className={`form-select-custom ${error ? 'is-invalid' : ''}`}
                                                                                                classNamePrefix='form-select-custom'
                                                                                                placeholder='Selecciona un flujo'
                                                                                                onChange={(data) => {
                                                                                                    onChange({
                                                                                                        ...data,
                                                                                                        text_btn: button.text
                                                                                                    });
                                                                                                }}
                                                                                                value={value}
                                                                                            />
                                                                                            <InvalidFeedback error={error} />
                                                                                        </>
                                                                                    )}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </>
                                                        )}



                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        <hr />

                                        <div className="card">
                                            <div className="card-body">
                                                <h2 className="card-title h4">Respuestas automáticas</h2>
                                                <p className="small ">
                                                    Envía un mensaje automático cuando el mensaje sea entregado, leído o cuando el usuario inicie una conversación.
                                                </p>

                                                <div className="mb-3">
                                                    <div className="form-check form-switch mb-4">
                                                        <input type="checkbox" className="form-check-input" id="active_replay_msg" {...register('active_replay_msg')} />
                                                        <label className="form-check-label" htmlFor="active_replay_msg">Activar respuestas automáticas</label>
                                                    </div>
                                                </div>

                                                {
                                                    active_replay_msg && (
                                                        <>
                                                            <h5>Tiempo de espera</h5>
                                                            <p>Configura el momento en que se enviará el mensaje automático.</p>
                                                            <div className="row">
                                                                <div className="col">
                                                                    <Input type='number' label='Tiempo *' errors={errors.replay_msg?.time_to_send} {...register('replay_msg.time_to_send', { required: true, min: { value: 0, message: 'El valor mínimo es 0' }, max: { value: watch('replay_msg.type_time') === 'minutes' ? 960 : 16, message: `El valor máximo es ${watch('replay_msg.type_time') === 'minutes' ? 960 : 16}` } })} />
                                                                </div>
                                                                <div className="col">
                                                                    <NativeSelect.default
                                                                        label={'Unidad *'}
                                                                        data={[{ value: 'minutes', text: 'Minutos' }, { value: 'hours', text: 'Horas' }]}
                                                                        errors={errors.replay_msg?.type_time}
                                                                        {...register('replay_msg.type_time', { required: true })}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <hr />

                                                            <h5 className="mb-3">Eventos</h5>
                                                            <div className="mb-3">
                                                                <div className="form-check form-switch mb-4">
                                                                    <input type="checkbox" className="form-check-input" id="replay_msg.conditions.delivery" {...register('replay_msg.conditions.delivery')} />
                                                                    <label className="form-check-label" htmlFor="replay_msg.conditions.delivery">Enviar mensaje cuando el mensaje haya sido entregado</label>
                                                                </div>
                                                            </div>
                                                            <div className="mb-3">
                                                                <div className="form-check form-switch mb-4">
                                                                    <input type="checkbox" className="form-check-input" id="replay_msg.conditions.read" {...register('replay_msg.conditions.read')} />
                                                                    <label className="form-check-label" htmlFor="replay_msg.conditions.read">Enviar mensaje cuando el mensaje haya sido leido</label>
                                                                </div>
                                                            </div>
                                                            <div className="mb-3">
                                                                <div className="form-check form-switch mb-4">
                                                                    <input type="checkbox" className="form-check-input" id="replay_msg.conditions.contact" {...register('replay_msg.conditions.contact')} />
                                                                    <label className="form-check-label" htmlFor="replay_msg.conditions.contact">Enviar mensaje cuando el usuario haya iniciado una conversación</label>
                                                                </div>
                                                            </div>

                                                            <h5 className="mb-3">Plantilla</h5>
                                                            <div className="mb-3">
                                                                <Controller
                                                                    control={control}
                                                                    name='replay_msg.plantilla_id'
                                                                    rules={{ required: true }}
                                                                    render={
                                                                        ({
                                                                            field: { onChange, value },
                                                                            fieldState: { error }
                                                                        }) => {
                                                                            return (
                                                                                <>
                                                                                    <Select
                                                                                        options={templates}
                                                                                        className={'form-select-custom ' + (error ? ' is-invalid' : '')}
                                                                                        classNamePrefix='form-select-custom'
                                                                                        placeholder={t('bulk-senders.message-template')}
                                                                                        onChange={(data: any) => onChange(data)}
                                                                                        value={value as any}
                                                                                    />
                                                                                    <InvalidFeedback error={error} />
                                                                                </>
                                                                            )
                                                                        }
                                                                    }
                                                                />
                                                            </div>


                                                            {(replyTemplateParameters.fields.length > 0 || replyBtnsParameters.fields.length > 0) && (
                                                                <div className="mb-3">
                                                                    <div className="alert alert-soft-secondary" role="alert">
                                                                        <h5>Variables de plantilla</h5>
                                                                        <p>La plantilla que seleccionaste requiere de variables extra antes de ser enviado, selecciona las columnas del archivo csv que corresponden a cada variables.</p>

                                                                        {replyTemplateParameters.fields.length > 0 && <h6>Variables de cuerpo de mensaje</h6>}
                                                                        {
                                                                            replyTemplateParameters.fields.map((field, index) => (
                                                                                <div className="d-flex align-items-center mb-2" key={field.id}>
                                                                                    <label className="form-label mx-3" >{`{{${field.label}}}`}</label>
                                                                                    <div className="flex-grow-1">
                                                                                        <Controller
                                                                                            control={control}
                                                                                            name={`replay_msg.template_variables.${index}.value`}
                                                                                            rules={{ required: true }}
                                                                                            render={
                                                                                                ({
                                                                                                    field: { onChange, value },
                                                                                                    fieldState: { error }
                                                                                                }) => {
                                                                                                    return (
                                                                                                        <>
                                                                                                            <Select
                                                                                                                options={fieldsCSVFile}
                                                                                                                className={'form-select-custom ' + (error ? ' is-invalid' : '')}
                                                                                                                classNamePrefix='form-select-custom'
                                                                                                                placeholder={`Seleccionar columna para variable {{${field.label}}}`}
                                                                                                                onChange={(data: any) => onChange(data.value)}
                                                                                                                value={fieldsCSVFile.find(row => row.value === value) || ''}
                                                                                                            />
                                                                                                            <InvalidFeedback error={error} />
                                                                                                        </>
                                                                                                    )
                                                                                                }
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            ))
                                                                        }

                                                                        {replyBtnsParameters.fields.length > 0 && <h6 className="mt-5">Variables de botón dinámico</h6>}
                                                                        {
                                                                            replyBtnsParameters.fields.map((btn, index) => (
                                                                                <div className="d-flex align-items-center mb-2" key={index}>
                                                                                    <label className="form-label mx-3" >Botón {btn.btn.text}</label>
                                                                                    <div className="flex-grow-1">
                                                                                        <Controller
                                                                                            control={control}
                                                                                            name={`replay_msg.btns_variables.${index}.value`}
                                                                                            rules={{ required: true }}
                                                                                            render={
                                                                                                ({
                                                                                                    field: { onChange, value },
                                                                                                    fieldState: { error }
                                                                                                }) => {
                                                                                                    return (
                                                                                                        <>
                                                                                                            <Select
                                                                                                                options={fieldsCSVFile}
                                                                                                                className={'form-select-custom ' + (error ? ' is-invalid' : '')}
                                                                                                                classNamePrefix='form-select-custom'
                                                                                                                placeholder={`Seleccionar columna para variable del botón ${btn.btn.text}`}
                                                                                                                onChange={(data: any) => onChange(data.value)}
                                                                                                                value={fieldsCSVFile.find(row => row.value === value) || ''}
                                                                                                            />
                                                                                                            <InvalidFeedback error={error} />
                                                                                                        </>
                                                                                                    )
                                                                                                }
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            ))
                                                                        }
                                                                    </div>
                                                                </div>
                                                            )
                                                            }

                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </>
                                )
                            }

                            {
                                campaignType === 'RCS' && (
                                    <>
                                        <div className="card">
                                            <div className="card-body">
                                                <h2 className="card-title h4">{t('bulk-senders.message-template')}</h2>
                                                <p className="small ">
                                                    {t('bulk-senders.select-template')}
                                                </p>

                                                <div className="mb-3">
                                                    <Controller
                                                        control={control}
                                                        name='plantilla'
                                                        rules={{ required: true }}
                                                        render={
                                                            ({
                                                                field: { onChange, value },
                                                                fieldState: { error }
                                                            }) => {
                                                                return (
                                                                    <>
                                                                        <Select
                                                                            options={templatesRCS}
                                                                            className={'form-select-custom ' + (error ? ' is-invalid' : '')}
                                                                            classNamePrefix='form-select-custom'
                                                                            placeholder={t('bulk-senders.message-template')}
                                                                            onChange={(data: any) => {
                                                                                onChange(data)
                                                                                setValue('buttons_flow', false);
                                                                                if (buttons && buttons.buttons) {
                                                                                    buttons.buttons.forEach((_, index) => {
                                                                                        setValue(`button_flow_select_${index}`, undefined);
                                                                                    });
                                                                                }
                                                                            }}
                                                                            value={value as any}
                                                                        />
                                                                        <InvalidFeedback error={error} />
                                                                    </>
                                                                )
                                                            }
                                                        }
                                                    />
                                                </div>


                                                {
                                                    (templateParameters.fields.length > 0 || btnsParameters.fields.length > 0) && (
                                                        <div className="mb-3">
                                                            <div className="alert alert-soft-secondary" role="alert">
                                                                <h5>Variables de plantilla</h5>
                                                                <p>La plantilla que seleccionaste requiere de variables extra antes de ser enviado, selecciona las columnas del archivo csv que corresponden a cada variables.</p>

                                                                {templateParameters.fields.length > 0 && <h6>Variables de cuerpo de mensaje</h6>}
                                                                {
                                                                    templateParameters.fields.map((field, index) => (
                                                                        <div className="d-flex align-items-center mb-2" key={field.id}>
                                                                            <label className="form-label mx-3" >{`{{${field.label}}}`}</label>
                                                                            <div className="flex-grow-1">
                                                                                <Controller
                                                                                    control={control}
                                                                                    name={`template_variables.${index}.value`}
                                                                                    rules={{ required: true }}
                                                                                    render={
                                                                                        ({
                                                                                            field: { onChange, value },
                                                                                            fieldState: { error }
                                                                                        }) => {
                                                                                            return (
                                                                                                <>
                                                                                                    <Select
                                                                                                        options={fieldsCSVFile}
                                                                                                        className={'form-select-custom ' + (error ? ' is-invalid' : '')}
                                                                                                        classNamePrefix='form-select-custom'
                                                                                                        placeholder={`Seleccionar columna para variable {{${field.label}}}`}
                                                                                                        onChange={(data: any) => onChange(data.value)}
                                                                                                        value={fieldsCSVFile.find(row => row.value === value) || ''}
                                                                                                    />
                                                                                                    <InvalidFeedback error={error} />
                                                                                                </>
                                                                                            )
                                                                                        }
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                }

                                                                {btnsParameters.fields.length > 0 && <h6 className="mt-5">Variables de botón dinámico</h6>}
                                                                {
                                                                    btnsParameters.fields.map((btn, index) => (
                                                                        <div className="d-flex align-items-center mb-2" key={index}>
                                                                            <label className="form-label mx-3" >Botón {btn.btn.text}</label>
                                                                            <div className="flex-grow-1">
                                                                                <Controller
                                                                                    control={control}
                                                                                    name={`btns_variables.${index}.value`}
                                                                                    rules={{ required: true }}
                                                                                    render={
                                                                                        ({
                                                                                            field: { onChange, value },
                                                                                            fieldState: { error }
                                                                                        }) => {
                                                                                            return (
                                                                                                <>
                                                                                                    <Select
                                                                                                        options={fieldsCSVFile}
                                                                                                        className={'form-select-custom ' + (error ? ' is-invalid' : '')}
                                                                                                        classNamePrefix='form-select-custom'
                                                                                                        placeholder={`Seleccionar columna para variable del botón ${btn.btn.text}`}
                                                                                                        onChange={(data: any) => onChange(data.value)}
                                                                                                        value={fieldsCSVFile.find(row => row.value === value) || ''}
                                                                                                    />
                                                                                                    <InvalidFeedback error={error} />
                                                                                                </>
                                                                                            )
                                                                                        }
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </div>
                                        <hr />

                                        <div className="card">
                                            <div className="card-body">
                                                <h2 className="card-title h4">Configuración de Flujos de Respuesta<i className="bi bi-share fw-bolder text-primary ms-1 fs-3"></i></h2>
                                                <p className="small mb-5">
                                                    Los flujos de respuesta son bots previamente configurados que se activan cuando el usuario responde un mensaje recibido o hace clic en un botón de la plantilla enviada. </p>

                                                <span className="divider-start text-primary fs-4 fw-bolder">Flujo General</span>

                                                <p className="small mb-5">
                                                    Se ejecuta si el usuario responde a un mensaje.
                                                </p>

                                                <div className="mb-5">
                                                    <div className="form-check form-switch mb-4">
                                                        <input type="checkbox" className="form-check-input" {...register('general_flow')} />
                                                        <label className="form-check-label">Activar Flujo general</label>
                                                    </div>
                                                </div>

                                                {
                                                    general_flow && (
                                                        <>
                                                            <h5 className="mb-2">Flujos <span className="text-danger">*</span></h5>
                                                            <div className="mb-7">
                                                                <Controller
                                                                    control={control}
                                                                    name='general_flow_select'
                                                                    rules={{ required: true }}
                                                                    render={
                                                                        ({
                                                                            field: { onChange, value },
                                                                            fieldState: { error }
                                                                        }) => {
                                                                            return (
                                                                                <>
                                                                                    <Select
                                                                                        options={flows}
                                                                                        className={'form-select-custom ' + (error ? ' is-invalid' : '')}
                                                                                        classNamePrefix='form-select-custom'
                                                                                        placeholder={'Selecciona un flujo'}
                                                                                        onChange={(data: any) => onChange(data)}
                                                                                        value={value as any}
                                                                                    />
                                                                                    <InvalidFeedback error={error} />
                                                                                </>
                                                                            )
                                                                        }
                                                                    }
                                                                />
                                                            </div>
                                                        </>
                                                    )
                                                }
                                                {buttons && buttons.buttons && buttons.buttons.length > 0 && (
                                                    <>
                                                        <span className="divider-start fs-4 fw-bolder text-primary">Flujo por botón</span>
                                                        <p className="small mb-5">
                                                            Se activa si el usuario hace clic en un botón de la plantilla, y cada botón puede tener un flujo diferente o compartir el mismo.
                                                        </p>

                                                        <div className="mb-7">
                                                            <div className="form-check form-switch mb-4">
                                                                <input type="checkbox" className="form-check-input" id="buttons_flow" {...register('buttons_flow')} />
                                                                <label className="form-check-label" htmlFor="buttons_flow">Activar Flujo por botón</label>
                                                            </div>
                                                            {buttons_flow && (
                                                                <h4 className="mb-2 text-success">Botones encontrados: {buttons.buttons.length}</h4>
                                                            )}
                                                        </div>

                                                        {buttons_flow && (
                                                            <>
                                                                <div className="row">
                                                                    {buttons.buttons.map((button, index) => (
                                                                        <div className="d-flex mb-7" key={index} style={{ width: '100%' }}>
                                                                            <div className="col-4">
                                                                                <h5 className="mb-2 text-muted">Texto del botón:</h5>
                                                                                <span className="d-block fw-bold text-primary">{button.text}</span>
                                                                            </div>
                                                                            <div className="col-8">
                                                                                <h5 className="mb-2 text-muted">Flujos (Opcional)</h5>
                                                                                <Controller
                                                                                    control={control}
                                                                                    name={`button_flow_select_${index}`}
                                                                                    rules={{ required: false }}
                                                                                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                                                                                        <>
                                                                                            <Select
                                                                                                options={flows}
                                                                                                className={`form-select-custom ${error ? 'is-invalid' : ''}`}
                                                                                                classNamePrefix='form-select-custom'
                                                                                                placeholder='Selecciona un flujo'
                                                                                                onChange={(data) => {
                                                                                                    onChange({
                                                                                                        ...data,
                                                                                                        text_btn: button.text
                                                                                                    });
                                                                                                }}
                                                                                                value={value}
                                                                                            />
                                                                                            <InvalidFeedback error={error} />
                                                                                        </>
                                                                                    )}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </>
                                                        )}



                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        <hr />
                                    </>
                                )
                            }
                            {
                                (campaignType === 'SMS' || send_sms_on_fail) && (
                                    <>
                                        <div className="card">
                                            <div className="card-body">
                                                <h2 className="card-title h4">{t('bulk-senders.message-sms')}</h2>
                                                <p className="small ">
                                                    {t('bulk-senders.message-sms-1')}
                                                </p>
                                                <p className="small mb-5">
                                                    {t('bulk-senders.message-sms-2')}
                                                </p>
                                                <div className="mb-5">
                                                    <div className="form-check form-switch mb-4">
                                                        <input type="checkbox" className="form-check-input" id="general_flow" {...register('message_var')} onChange={(e) => {
                                                            register('message_var').onChange(e);
                                                            setMessageVar('');
                                                            setValue('sms_message', '');
                                                            setValue('headers_message_var', '');
                                                        }} />
                                                        <span className="divider-start text-primary fs-4 fw-bolder">Usar columna con mensaje.</span>
                                                        <p className="small mb-5 ms-3">
                                                            Utiliza una columna de tu archivo CSV que contenga el mensaje completo, con o sin las variables que necesites.
                                                        </p>

                                                    </div>
                                                </div>

                                                {
                                                    message_var && (
                                                        <>
                                                            <h5 className="mb-2">Columnas <span className="text-danger">*</span></h5>
                                                            <div className="mb-5">
                                                                <Controller
                                                                    control={control}
                                                                    name='headers_message_var'
                                                                    rules={{ required: true }}
                                                                    render={
                                                                        ({
                                                                            field: { onChange, value },
                                                                            fieldState: { error }
                                                                        }) => {
                                                                            return (
                                                                                <>
                                                                                    <Select
                                                                                        options={fieldsCSVFile}
                                                                                        className={'form-select-custom ' + (error ? ' is-invalid' : '')}
                                                                                        classNamePrefix='form-select-custom'
                                                                                        placeholder={'Selecciona una columna'}
                                                                                        onChange={(data: any) => {
                                                                                            onChange(data);
                                                                                            addVariable(data.value);
                                                                                            setValue('sms_message', replaceVariablesInMessage(`{{${data.value}}}`));
                                                                                        }}
                                                                                        value={value as any}
                                                                                    />
                                                                                    <InvalidFeedback error={error} />
                                                                                </>
                                                                            )
                                                                        }
                                                                    }
                                                                />
                                                            </div>
                                                        </>
                                                    )
                                                }
                                                {!message_var && (
                                                    <div className="">
                                                        <div className="alert alert-soft-secondary" role="alert">
                                                            <h5>{t('bulk-senders.variable-availability')}</h5>
                                                            <p>{t('bulk-senders.variable-text')}</p>

                                                            <div className="d-flex flex-wrap">
                                                                {
                                                                    fieldsCSVFile.map((f, index) => <span key={index} className="badge bg-info  cursor-pointer me-2 mb-2" onClick={() => addVariable(f.value)}>{f.value}</span>)
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="mb-3">
                                                    <Controller
                                                        control={control}
                                                        name='sms_message'
                                                        rules={{ required: true, maxLength: { message: sms_link ? '106' : undefined, value: sms_link ? 106 : undefined } }}
                                                        render={
                                                            ({
                                                                field: { onChange, value },
                                                                fieldState: { error }
                                                            }) => {
                                                                return (

                                                                    <>
                                                                        {!message_var && (
                                                                            <>
                                                                                <label className="form-label flex-grow-1" >{t('bulk-senders.message-label')}</label>

                                                                                <div className="d-flex mb-4">
                                                                                    <ContentEditable
                                                                                        className={'form-control form-control-lg sms-textarea' + (error ? ' is-invalid ' : '')}
                                                                                        html={formatPreviewSMS()}
                                                                                        disabled={message_var}
                                                                                        onChange={(event) => {
                                                                                            onChange(event.currentTarget.innerText)
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                                <InvalidFeedback error={errors.sms_message} className='d-inline' />
                                                                                {sms_link ? (
                                                                                    <>
                                                                                        <div className="form-text mt-1  d-inline float-end">{sms_message.length}/'106'</div>
                                                                                        <div className="clearfix"></div>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <div className="d-flex flex-column pe-0 pe-sm-10 mb-7">
                                                                                            <h5 className="mb-1">
                                                                                                Caracteres utilizados: <span className="text-info fw-bolder">{sms_message.length}</span>
                                                                                            </h5>
                                                                                            <h5 className="mb-1">
                                                                                                Mensajes a cobrar: <span className="text-danger fw-bolder">{Math.ceil(sms_message.length / 160)}</span>
                                                                                            </h5>
                                                                                            <span>Se cobrarán 1 mensaje por cada 160 caracteres utilizados.</span>
                                                                                        </div>

                                                                                    </>
                                                                                )}
                                                                            </>
                                                                        )}


                                                                    </>
                                                                )
                                                            }
                                                        }
                                                    />
                                                </div>

                                                <div className="mb-4">
                                                    <label className="form-label" >{t('bulk-senders.mask-label')}</label>
                                                    <Controller
                                                        control={control}
                                                        name='sms_mascara'
                                                        rules={{ required: true }}
                                                        render={
                                                            ({
                                                                field: { onChange, value },
                                                                fieldState: { error }
                                                            }) => {

                                                                return (
                                                                    <>
                                                                        <Select
                                                                            name="Selecciona una máscara de salida"
                                                                            options={masks}
                                                                            className={error ? 'form-select-custom is-invalid' : ''}
                                                                            classNamePrefix='form-select-custom'
                                                                            placeholder={t('bulk-senders.mask-placeholder')}
                                                                            onChange={(option) => onChange(option.value)}
                                                                            value={masks.find(row => row.value === value) || ''}
                                                                        />
                                                                        <InvalidFeedback error={error} />
                                                                    </>
                                                                )
                                                            }
                                                        }
                                                    />
                                                </div>

                                                <div className="">
                                                    <div className="form-check form-switch ">
                                                        <input type="checkbox" className="form-check-input" id="sms_link" {...register('sms_link')} />
                                                        <label className="form-check-label" htmlFor="sms_link">{t('bulk-senders.switch-wa')}</label>
                                                    </div>

                                                    {
                                                        sms_link && (
                                                            <>
                                                                <div className="alert alert-warning mt-5">
                                                                    <div className="d-flex">
                                                                        {/* <i className="bi-exclamation-circle h1 mb-0 me-2"></i> */}
                                                                        <div>
                                                                            <h4>{t('bulk-senders.warning-title')}</h4>
                                                                            <p className="">{t('bulk-senders.warning-text-1')}</p>
                                                                            <p className="m-0 ">{t('bulk-senders.warning-text-2')}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row ">
                                                                    <div className="col-6">
                                                                        <div className="mb-3">
                                                                            <label className="form-label" >{t('bulk-senders.wa-number-label')}</label>
                                                                            <Controller
                                                                                control={control}
                                                                                name='sms_link_number'
                                                                                rules={{ required: true }}
                                                                                render={
                                                                                    ({
                                                                                        field: { onChange, value },
                                                                                        fieldState: { error }
                                                                                    }) => {

                                                                                        return (
                                                                                            <>
                                                                                                <Select
                                                                                                    options={whatsAppnumbers}
                                                                                                    className={error ? 'form-select-custom is-invalid' : ''}
                                                                                                    classNamePrefix='form-select-custom'
                                                                                                    placeholder=''
                                                                                                    onChange={(option) => onChange(option.value)}
                                                                                                    value={whatsAppnumbers.find(row => row.value === value) || ''}
                                                                                                />
                                                                                                <InvalidFeedback error={error} />
                                                                                            </>
                                                                                        )
                                                                                    }
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <div className='mb-3'>
                                                                            <Input label={t('bulk-senders.text-label')} errors={errors.sms_link_text} {...register('sms_link_text', { required: true, maxLength: { message: '24', value: 24 } })} />
                                                                            <div className="form-text mt-1  d-inline float-end">{sms_link_text.length}/24</div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="d-grid mt-2">
                                                                    <a href={`https://wa.me/${sms_link_number}?text=${encodeURIComponent(sms_link_text)}`} target="_blank" rel="noreferrer" className="btn btn-secondary"><i className="bi-box-arrow-up-right ms-2" /> {t('bulk-senders.preview-btn')}</a>
                                                                </div>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <hr />

                                        <div className="card">
                                            <div className="card-body">
                                                <h2 className="card-title h4">Configuración de Flujos de Respuesta<i className="bi bi-share fw-bolder text-primary ms-1 fs-3"></i></h2>
                                                <p className="small mb-5">
                                                    Los flujos de respuesta son bots previamente configurados que se activan cuando el usuario responde un mensaje recibido o hace clic en un botón de la plantilla enviada. </p>

                                                <span className="divider-start text-primary fs-4 fw-bolder">Flujo General</span>

                                                <p className="small mb-5">
                                                    Se ejecuta si el usuario responde a un mensaje.
                                                </p>

                                                <div className="mb-5">
                                                    <div className="form-check form-switch mb-4">
                                                        <input type="checkbox" className="form-check-input" id="general_flow" {...register('general_flow')} />
                                                        <label className="form-check-label" htmlFor="general_flow">Activar Flujo general</label>
                                                    </div>
                                                </div>

                                                {
                                                    general_flow && (
                                                        <>
                                                            <h5 className="mb-2">Flujos <span className="text-danger">*</span></h5>
                                                            <div className="mb-7">
                                                                <Controller
                                                                    control={control}
                                                                    name='general_flow_select'
                                                                    rules={{ required: true }}
                                                                    render={
                                                                        ({
                                                                            field: { onChange, value },
                                                                            fieldState: { error }
                                                                        }) => {
                                                                            return (
                                                                                <>
                                                                                    <Select
                                                                                        options={flows}
                                                                                        className={'form-select-custom ' + (error ? ' is-invalid' : '')}
                                                                                        classNamePrefix='form-select-custom'
                                                                                        placeholder={'Selecciona un flujo'}
                                                                                        onChange={(data: any) => onChange(data)}
                                                                                        value={value as any}
                                                                                    />
                                                                                    <InvalidFeedback error={error} />
                                                                                </>
                                                                            )
                                                                        }
                                                                    }
                                                                />
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </>
                                )
                            }

                        </div>

                        <div className="col-4">
                            <div className={`bg-whatsapp  p-4 rounded shadow-sm border h-100 ${campaignType === 'WA' ? '' : 'sms'}`}>
                                <div className="sticky">
                                    <h4>{t('bulk-senders.preview-title')}</h4>

                                    {
                                        (campaignType === 'WA' || campaignType === 'RCS') && template.length > 0 && (<PreviewMessageWa header={header} body={replaceVariablesInBody(body, 'message')} footer={footer} buttons={buttons} />)
                                    }

                                    {
                                        active_replay_msg && (
                                            <>
                                                <h4 className="mt-5">Mensaje de respuesta</h4>
                                                <PreviewMessageWa header={replyHeader} body={replaceVariablesInBody(replyBody, 'replayMessage')} footer={replyFooter} buttons={replyButtons} />
                                            </>
                                        )
                                    }

                                    {
                                        campaignType === 'SMS' && (
                                            <>
                                                <div className="mt-3">
                                                    <div className="preview-template">
                                                        {sms_message_final && (
                                                            <div dangerouslySetInnerHTML={{ __html: replaceVariablesInMessage(sms_message_final).replace(/\n/g, '<br/>') }}></div>
                                                        )}
                                                    </div>

                                                </div>

                                                {/* <div className="d-grid mt-3">
                                                        <button className="btn btn-dark btn-sm" ><i className="bi-send-fill"></i> Enviar mensaje de prueba </button>
                                                    </div> */}
                                            </>
                                        )
                                    }


                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row align-items-center mt-3">
                        <div className="col-sm mb-2 mb-sm-0 d-flex align-items-center">

                        </div>

                        <div className="col-sm-auto">
                            <Button className="btn btn-primary btn-sm" onClick={handleSubmit(submit)} disabled={!isValid} isLoading={isSubmitting} ><i className="bi-save2 me-2"></i> {t('btn-save')} </Button>
                        </div>
                    </div>

                </div>
                <Footer />
            </main>
        </>
    )
}
export default BulkSendersCreatePage